import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackClickShowPhone } from 'shared/components/author/tracking';
import { getRosreestrInfo } from 'shared/selectors/offerData/getRosreestrInfo';
import { selectKpId } from 'shared/selectors/offerData/kp';
import { selectAgent } from 'shared/selectors/selectAgent';
import { SimpleBotDetector } from 'shared/utils/simpleBotDetector';

import { openChat } from '../../../actions/chat';
import { SubscriptionAuthorActions } from '../../../components/subscriptionBrand';
import {
  selectIsOfferOwnedByUser,
  selectIsAuthenticated,
  offerSelector,
  selectABGroup,
  selectUser,
} from '../../../selectors';
import { selectIsChatsEnabled, selectIsOfferChatExists } from '../../../selectors/offerChat';
import { offerPreparedPhonesSelector } from '../../../selectors/offerData/offer/offerPreparedPhonesSelector';

export const SubscriptionAuthorActionsContainer = () => {
  const isOfferChatExists = useSelector(selectIsOfferChatExists);
  const isOfferOwnedByUser = useSelector(selectIsOfferOwnedByUser);
  const phones = useSelector(offerPreparedPhonesSelector);
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const offer = useSelector(offerSelector);
  const agent = useSelector(selectAgent);
  const abGroup = useSelector(selectABGroup);
  const user = useSelector(selectUser);
  const kpId = useSelector(selectKpId);
  const rosreestrInfo = useSelector(getRosreestrInfo);

  const [isPhonesVisible, setIsPhonesVisible] = React.useState(false);
  const [botDetector] = React.useState<SimpleBotDetector>(new SimpleBotDetector());

  const isMessageButtonVisible = isChatsEnabled && (isOfferChatExists || !isOfferOwnedByUser);

  React.useEffect(() => {
    botDetector.init();

    return () => botDetector.destroy();
  }, []);

  const dispatch = useDispatch();

  const handleShowPhonesClick = React.useCallback(() => {
    trackClickShowPhone({
      offer,
      agent,
      abGroup,
      user,
      kpId,
      isBot: !botDetector.isHuman(),
      rosreestrInfo,
    });

    setIsPhonesVisible(true);
  }, [offer, agent, abGroup, user, kpId, botDetector, rosreestrInfo, setIsPhonesVisible]);

  const handleSendMessageClick = React.useCallback(() => {
    if (!isAuthenticated) {
      window.waitForLoginPopup?.('chats', () => {
        dispatch(openChat());

        return Promise.resolve();
      });

      return;
    }

    dispatch(openChat());
  }, [isAuthenticated, dispatch]);

  return (
    <SubscriptionAuthorActions
      isPhonesVisible={isPhonesVisible}
      phones={phones}
      isMessageButtonVisible={isMessageButtonVisible}
      messageButtonText="Написать сообщение"
      handleShowPhonesClick={handleShowPhonesClick}
      handleSendMessageClick={handleSendMessageClick}
    />
  );
};
